import { withNamespaces } from 'react-i18next';
import { Col, Input, Row } from 'reactstrap';
import { AvField } from 'availity-reactstrap-validation';

import SectionCard from '../section-card';
import SettingsField from '../settings-field';
import { PROVIDER_ORDER } from '../../helpers';

const MailboxDetails = ({
    t,
    isFetching,
    provider,
    presets,
    defaultSettings,
    isMicrosoft,
    onProviderChange,
    onEmailAddressChange,
}) => {
    return (
        <SectionCard
            number={1}
            title={t('Mailbox details')}
            description={t('The shared mailbox used to send emails and optionally sync incoming messages.')}
        >
            <Row>
                <Col sm="12" md="6" className="mb-3">
                    <SettingsField
                        id="provider"
                        label={t('Email provider')}
                        required
                        isFetching={isFetching}
                        info={t('Company Microsoft 365 (even with a custom domain) is not Gmail. Always choose Microsoft 365 / Outlook for work mailboxes.')}
                    >
                        <Input
                            id="provider"
                            type="select"
                            className="form-control"
                            value={provider}
                            onChange={(e) => onProviderChange(e.target.value)}
                        >
                            {PROVIDER_ORDER.map((key) => (
                                <option key={key} value={key}>
                                    {t(presets[key]?.label || key)}
                                </option>
                            ))}
                        </Input>
                    </SettingsField>
                </Col>

                <Col sm="12" md="6" className="mb-3">
                    <SettingsField
                        id="emailAddress"
                        label={t('Email address')}
                        required
                        isFetching={isFetching}
                        info={isMicrosoft
                            ? t('Mailbox UPN, for example privacy@company.com. This is the Microsoft account you will connect.')
                            : t('The mailbox address used to send and sync email.')}
                    >
                        <AvField
                            id="emailAddress"
                            name="emailAddress"
                            type="email"
                            placeholder="mailbox@company.com"
                            errorMessage={t('This field cannot be blank')}
                            className="form-control"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: t('This field cannot be blank'),
                                },
                                email: { errorMessage: t('Your email is invalid') },
                            }}
                            value={defaultSettings?.emailAddress || ''}
                            onChange={onEmailAddressChange}
                        />
                    </SettingsField>
                </Col>

                <Col sm="12" md="6">
                    <SettingsField
                        id="displayName"
                        label={t('Display name')}
                        required
                        isFetching={isFetching}
                        hint={t('Shown as the sender name on outgoing emails.')}
                    >
                        <AvField
                            id="displayName"
                            name="displayName"
                            type="text"
                            errorMessage={t('This field cannot be blank')}
                            className="form-control"
                            validate={{
                                required: { value: true },
                            }}
                            value={defaultSettings?.displayName || ''}
                        />
                    </SettingsField>
                </Col>
            </Row>
        </SectionCard>
    );
};

export default withNamespaces()(MailboxDetails);
